var _rect, _text, _text2, _g, _g2, _g3, _text3, _text4, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProbeFig1Fanout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 560",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 560,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "One document, six critics, one verdict")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Every lens runs isolated, so findings cannot converge before the synthesis reads them")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 230,
    width: 150,
    height: 110,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 268,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Your draft"), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 290,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "a decision doc,"), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 305,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "a plan, raw notes"), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 326,
    fontSize: 11,
    fontFamily: "ui-monospace, monospace",
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "/probe:go doc.md"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#9CB3A6",
    strokeWidth: 1.3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 265 C 260 200, 300 140, 360 122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 275 C 262 232, 300 208, 360 190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 283 C 268 268, 310 262, 360 258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 291 C 268 300, 310 312, 360 322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 299 C 262 336, 300 366, 360 388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 307 C 260 372, 300 434, 360 454"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 100,
    width: 220,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 127,
    textAnchor: "middle"
  }, "clarify the thinking"), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 155,
    x2: 584,
    y2: 155,
    stroke: "#D9E3DC",
    strokeDasharray: "3 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 168,
    width: 220,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 195,
    textAnchor: "middle"
  }, "challenge assumptions"), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 223,
    x2: 584,
    y2: 223,
    stroke: "#D9E3DC",
    strokeDasharray: "3 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 236,
    width: 220,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 263,
    textAnchor: "middle"
  }, "evidence basis"), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 291,
    x2: 584,
    y2: 291,
    stroke: "#D9E3DC",
    strokeDasharray: "3 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 304,
    width: 220,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 331,
    textAnchor: "middle"
  }, "alternative viewpoints"), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 359,
    x2: 584,
    y2: 359,
    stroke: "#D9E3DC",
    strokeDasharray: "3 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 372,
    width: 220,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 399,
    textAnchor: "middle"
  }, "implications and consequences"), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 427,
    x2: 584,
    y2: 427,
    stroke: "#D9E3DC",
    strokeDasharray: "3 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 440,
    width: 220,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 467,
    textAnchor: "middle"
  }, "question the question"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 518,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "six agents in parallel, no context shared")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 533,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "with each other or with the author")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#9CB3A6",
    strokeWidth: 1.3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584 122 C 660 140, 690 200, 742 250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 190 C 660 210, 690 236, 742 268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 258 C 660 268, 690 275, 742 284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 326 C 660 316, 690 308, 742 300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 394 C 660 372, 690 340, 742 316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 462 C 660 434, 690 380, 742 334"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 228,
    width: 170,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 262,
    fontSize: 15,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "Synthesis"), /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 286,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "reads all six,"), /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 301,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "weighs the overlap,"), /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 316,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "names what is missing"), /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 341,
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "tolerates a partial set"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#9CB3A6",
    strokeWidth: 1.3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916 293 L 972 293"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 976,
    y: 240,
    width: 176,
    height: 106,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1064,
    y: 274,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Verdict"), /*#__PURE__*/React.createElement("text", {
    x: 1064,
    y: 296,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "ready or not ready,"), /*#__PURE__*/React.createElement("text", {
    x: 1064,
    y: 311,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "risks ranked, checklist"), /*#__PURE__*/React.createElement("text", {
    x: 1064,
    y: 326,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "before proceeding"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbeFig1Fanout);
export default __webpack_public_path__ + "static/media/probe-fig1-fanout.15e3065dd29d053e1fb1913847021d9f.svg";
export { ForwardRef as ReactComponent };